module.exports = __webpack_public_path__ + "static/media/menu-goals-active.f9966f57.svg";